module.exports = __webpack_public_path__ + "static/media/guide_Page_08.c9bebdb4.png";